module.exports = __webpack_public_path__ + "static/FSlogosmall-f408a49ce8ee8f89938e01f6273ec4b3.png";